<template>
<div class="introduction">
  <div class="container">
    <div class="container-list">
      <span class="title">
        {{introduction.INTRODUCTION_TITLE}}
      </span>
      <div class="text">
        {{introduction.INTRODUCTION_TEXT}}
      </div>
    </div>
    <div class="join">
    <!-- <div :class="{join:true,joiner:joinershow}"> -->
      <div class="item">
        <div class="itemimg">
          <img style="border-radius: 3%" :src="introduction.INTRODUCTION_IMG" alt="">
        </div>
        <div class="itemtext">
            <p style="font-size:15px">
              {{introduction.INTRODUCTION_P}}
              <a href="/#/abouts">详情...</a></p>
          <br>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      introduction: []
    }
  },
  mounted () {
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.introduction = response.data.INTRODUCTION
        // console.log(this.cont)
      })
  }
  // },
  // methods: {
  //   more: function (event) {
  //     window.location.href = '#/scope'
  //   }
  // }
}
</script>

<style lang="less" scoped>
@import url('../../static/less/less.css');
@media only screen and (min-width: 960px) {}
@media only screen and (min-width: 767px) and (max-width: 960px) {}
@media only screen and (max-width: 767px) {
    .itemimg {
      display: none;
    }
}
.introduction {
  text-align: center;
  padding-top: 80px;
  display: flex;
  // min-width: 1200px;
}
.container {
  width: 96%;
  // padding: 55px 10% 60px 10%;
  background-color: #fdfffc;
  margin: 0 auto;
  max-width: 1200px;
  &-list {
    position: relative;
    animation-name: FadeDown;
    animation-duration: 1.5s;
    text-align: center;
    margin-bottom: 30px;
    .title {
      font-size: 27px;
      color: #333;
    }
    .text {
      color: #818181;
    }
  }
  .join {
    padding: 10px 0;
    visibility: visible;
      animation-name: fadeUp;
      animation-duration: 1s;
      animation-delay:1s;
      animation-fill-mode: both;
    // width: 96%;
    // max-width: 1200px;
    // margin: 0 auto;
    // text-align: center;
    // opacity: 0;
    .item {
      width: 100%;
      // height: 298px;
    //   border: 1px solid rgb(217, 217, 217);
      color: rgb(126, 126, 126);
      font-size: 14px;
      // line-height: 18px;
      display: flex;
      .itemimg {
        border-width: 0px 0px 0px 0px;
        border-right-style: solid;
        border-right-color: #d9d9d9;
        // overflow: hidden;
        // display: block;
        // float: left;
        // height: 180px;
        width: 100%;
        // width: 50%;
        img {
          height: 100%;
          width: 245px;
        }
      }
      .itemtext {
        // float: left;
        // width: 25%;
        padding: 30px;
        text-align: left;
        text-indent: 2em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/introduction.vue